export enum RequestQuestionAnswer {
	Yes = "YES",
	No = "NO",
}
